/**
 * reCAPTCHA badge can be hidden, but reCAPTCHA branding should be included instead
 * https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 * @return {JSX.Element}
 */
const Recaptcha3Text = () => {

    return (
        <div className="text-xs">
            This site is protected by reCAPTCHA and the Google<br/> <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service</a> apply.
        </div>
    );
};

export default Recaptcha3Text;